import {MAXIMUM_NUMBER_OF_CUSTOM_REPORTS} from '../../../const';
import usePayment from '../../../hooks/providers/usePayment';
import useProfile from '../../../hooks/providers/useProfile';
import useReport from '../../../hooks/providers/useReport';
import useWorkspaces from '../../../hooks/providers/useWorkspaces';
import CreateReportOrWorkspaceButton from '../CreateReportOrWorkspaceButton';

const CreateReportButton = () => {
  const {isDefaultWorkspace, isUserInWorkspace, selectedWorkspace, setCreateReportModalOpen, setIsCustomReportCreation, setAnchorElReportTabsMenu} = useWorkspaces();
  const {reports} = useReport();
  const {profile} = useProfile();
  const {isAdmin} = usePayment();

  const numberOfReportsCreatedByUser = (reports?.filter(r => r.isEditable) || []).length;
  const maximumNumberOfReportsReached = numberOfReportsCreatedByUser > MAXIMUM_NUMBER_OF_CUSTOM_REPORTS;

  const handleClick = () => {
    if (maximumNumberOfReportsReached) return;
    setCreateReportModalOpen(true);
    setIsCustomReportCreation(true);
    setAnchorElReportTabsMenu(null);
  };

  const isUserPartOfCurrentWorkspace = isUserInWorkspace(profile?.id, selectedWorkspace);

  const getTooltipMessage = () => {
    if (isAdmin) return '';

    if (!isUserPartOfCurrentWorkspace) {
      return "Seuls les utilisateurs d'un espace de travail peuvent créer un rapport au sein de cet espace.";
    }

    if (maximumNumberOfReportsReached) {
      return 'Vous avez atteint le nombre maximum de rapports. Vous devrez en supprimer un pour pouvoir en créer de nouveau.';
    }

    return '';
  };

  const isButtonDisabled = !isAdmin && (isDefaultWorkspace || !isUserPartOfCurrentWorkspace);

  const tooltipMessage = getTooltipMessage();

  return <CreateReportOrWorkspaceButton disabled={isButtonDisabled} maxLimitReached={maximumNumberOfReportsReached} onClick={handleClick} tooltipTitle={tooltipMessage} label="Ajouter un rapport" />;
};

export default CreateReportButton;
